import { Link } from '@tanstack/react-router';
import moment from 'moment';
import { useMemo } from 'react';

import { CachedImage } from '@common/ui/CachedImage';
import { Card } from '@common/ui/Card';

import styles from '../../MyProfileInfo.module.scss';

export interface PremiumCardProps {
  has_premium: boolean;
  premium_expiration_date?: string | null;
}

export const PremiumCard = ({
  has_premium,
  premium_expiration_date,
}: PremiumCardProps) => {
  const date = moment(premium_expiration_date);

  const expirationText = useMemo(() => {
    const now = moment();
    const years = date.diff(now, 'years');
    const months = date.diff(now.clone().add(years, 'years'), 'months');
    const days = date.diff(
      now.clone().add(years, 'years').add(months, 'months'),
      'days',
    );
    const hours = date.diff(now, 'hours');
    const minutes = date.diff(now, 'minutes');

    if (years >= 1) {
      if (months === 0) {
        return `${years} г`;
      }

      return `${years} г и ${months} мес`;
    }

    if (date.diff(now, 'months') >= 1) {
      const fullMonths = date.diff(now, 'months');

      if (days === 0) {
        return `${fullMonths} мес`;
      }

      return `${fullMonths} мес и ${days} дн`;
    }

    if (date.diff(now, 'days') === 0) {
      if (hours === 0) {
        return `${minutes} мин`;
      }

      return `${hours} ч`;
    }

    return `${date.diff(now, 'days')} дн`;
  }, [date]);

  return (
    <div
      className={styles.premiumCard}
      data-has-premium={has_premium}
      data-test-id={
        has_premium
          ? 'my-profile-info-premium-active'
          : 'my-profile-info-premium-inactive'
      }
    >
      {!has_premium && (
        <Link to="/premium" data-test-id="my-profile-info-premium-link">
          <Card testId="my-profile-info-premium" className={styles.premium}>
            <div className={styles.title}>Premium</div>
            <div className={styles.subtitle}>
              Смотрите анкеты тех, кому вы нравитесь
            </div>
            <CachedImage
              testId="cached-image"
              className={styles.image}
              src="/icons/3d-icons/premium.png"
              alt="premium-image"
            />
          </Card>
        </Link>
      )}

      {has_premium && (
        <Link to="/premium" data-test-id="my-profile-info-premium-link">
          <Card testId="my-profile-info-premium" className={styles.premium}>
            <div className={styles.title}>Продли Premium</div>
            <div className={styles.subtitle}>До окончания {expirationText}</div>
            <CachedImage
              testId="cached-image"
              className={styles.image}
              src="/icons/3d-icons/premium.png"
              alt="premium-image"
            />
          </Card>
        </Link>
      )}
    </div>
  );
};
